import styled from 'react-emotion';

export const AvatarContainer = styled('div')`
  padding-left: 8px;
  height: 24px;
`;
